module.exports = __webpack_public_path__ + "img/ic-logo-header.aa0874e9.svg";